import { Card, CardProps, Grow, makeStyles, useTheme } from '@material-ui/core'
import React from 'react'
import { styles } from './CardWithTransition.styles'

export interface CardWithTransitionProps extends CardProps {
  show: boolean
  unmountOnExit?: boolean
}

export const CardWithTransition: React.FC<CardWithTransitionProps> = ({
  show,
  unmountOnExit,
  ...props
}) => {
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  return (
    <Grow
      in={show}
      unmountOnExit={unmountOnExit}
      style={{ transformOrigin: '0 0 0' }}
      {...(show ? { timeout: 500 } : {})}
    >
      <Card {...props}>{props.children}</Card>
    </Grow>
  )
}
